module.exports = __webpack_public_path__ + "static/media/crystal-usecase.150889b1.png";